import React from "react";
import { useQuery } from "@apollo/client";
import DtsReactTable from "../../reuseableComponents/dtsReactTable/DtsReactTable";
import { frequencyType, sampleType } from "../../../utilities/constants/WaterSystemConstants";
import { GET_CHLORINE_RESIDUAL_MONITORING } from "../../../queries/archiveQrys/MonitoringScheduleReportQueries";
import SkeletonLoader from "../../reuseableComponents/loaders/SkeletonLoader";
import ErrorHandler from "../../reuseableComponents/ErrorHandler";

const ChlorineResidualMonitoringTable = (props) => {
  const { systemId } = props;

  const columns = [
    {
      Header: "ID",
      accessor: "facilityCode",
      width: 75
    },
    {
      Header: "Facility Name",
      accessor: "facilityName",
      width: 250
    },
    {
      Header: "Samples Required",
      accessor: "samplesRequired"
    },
    {
      Header: "Type",
      accessor: (d) => {
        return d.sampleType ? sampleType[d.sampleType] : "";
      }
    },
    {
      Header: "Frequency",
      accessor: (d) => {
        return d.sampleFrequency ? frequencyType[d.sampleFrequency] : "";
      }
    }
  ];

  const { loading, error, data } = useQuery(GET_CHLORINE_RESIDUAL_MONITORING, { variables: { systemId } });

  if (loading) return <SkeletonLoader width='100%' />;
  if (error) return <ErrorHandler error={error} />;

  return (
    <>
      {data.getPublicChlorineResidualMonitoring.length > 0 ? (
        <DtsReactTable data={data.getPublicChlorineResidualMonitoring} columns={columns} headerColor='ddw' cypressid="chlorineResTbl"/>
      ) : (
        <span>No Chlorine Residual Monitoring was found in the database.</span>
      )}
    </>
  );
};

export default ChlorineResidualMonitoringTable;
